import React from 'react'
import { Route, Switch } from 'react-router'
import { connect } from 'react-redux'

import loadable from 'components/utils/lazyImport'
import config from 'constants/config'
import { useTripPermissions } from 'tripPlanner/hooks/useTripPermissions'
import { LE_AGENT_HUB_COMPLETE_ACCOUNT_SETUP } from 'agentHub/routes/AgentHubRoutes'
import { useAppSelector } from 'hooks/reduxHooks'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { CHECKOUT_HEADER_PATHS } from './constants'

const HeaderMain = loadable(() => import(/* webpackChunkName: 'HeaderMain' */ 'components/App/Header/HeaderMain/HeaderMain'), <div />)
const HeaderCheckout = loadable(() => import(/* webpackChunkName: 'HeaderCheckout' */ 'components/App/Header/HeaderCheckout'), <div />)
const HeaderTripPlannerImmersive = loadable(() => import(/* webpackChunkName: 'TripPlannerImmersiveHeader' */ 'tripPlanner/components/ImmersiveHeader'), <div />)
const AgentHubGuestHeader = loadable(() => import(/* webpackChunkName: 'AgentHubGuestHeader' */ 'agentHub/components/AgentHubGuestHeader'), <div />)

const routesWithNoHeader = [
  '/:regionCode/gift-card/:code',
  '/:regionCode/order/:orderId/experience-gift-details',
  '/:regionCode/trip-planner/trip',
  '/:regionCode/trip-planner/public-trip/:id',
  '/:regionCode/trip-planner/generate-trip',
  '/:regionCode/search/map',
  '/:regionCode/search/store/map',
  '/:regionCode/search/homes-and-villas/map',
  '/:regionCode/search/experiences/map',
  '/:regionCode/account/my-escapes/experiences/:experienceItemId/voucher',
  `/:regionCode${LE_AGENT_HUB_COMPLETE_ACCOUNT_SETUP}`,
  '/:regionCode/trip-planner/chat-trip-planner/:chatId?',
]

const stickySearchHeaderPaths = [
  '/:regionCode/hotels',
  '/:regionCode/tours',
  '/:regionCode/cruises',
  '/:regionCode/car-hire',
  '/:regionCode/experiences',
  '/:regionCode/flights',
  '/:regionCode/trip-planner',
  '/:regionCode/trip-planner/about',
  '/:regionCode',
]

const desktopAndLargerOnlyHeaderPaths = [
  '/:regionCode/support',
]

interface Props {
  tripPlannerTripId?: string
}

function HeaderRoutes(props: Props) {
  const { tripPlannerTripId } = props
  const { canEdit } = useTripPermissions(tripPlannerTripId)

  const agentHubAccountSetupComplete = useAppSelector(state => state.agentHub.agentHubAccount.account?.status === 'onboarded')

  return (
    <Switch>
      <Route path={routesWithNoHeader} />
      <Route path={CHECKOUT_HEADER_PATHS} component={HeaderCheckout} />
      {config.agentHub.isEnabled && !agentHubAccountSetupComplete && <Route component={AgentHubGuestHeader} />}
      {tripPlannerTripId && canEdit && <Route>
        <HeaderTripPlannerImmersive tripId={tripPlannerTripId} />
      </Route>}
      <Route exact path={stickySearchHeaderPaths}>
        <HeaderMain stickySearch />
      </Route>
      <Route exact path={desktopAndLargerOnlyHeaderPaths}>
        <CSSBreakpoint min="desktop">
          <HeaderMain />
        </CSSBreakpoint>
      </Route>
      <Route component={HeaderMain} />
    </Switch>
  )
}

function mapStateToProps(state: App.State) {
  return {
    tripPlannerTripId: state.tripPlanner.currentTripId,
  }
}

export default connect(mapStateToProps)(HeaderRoutes)
